﻿import { global, setModalFormZIndex,isEmpty,isUnDefined } from "../Common/saop-common";

export enum SaopMsgDlgType {
    mtInformation = 1
    ,mtWarning = 2
    ,mtError = 3
    //, mtConfirmation, mtCustom
}

export enum SaopMsgDlgButton {
    mbNone = 0
    ,mbOK = 1
    ,mbCancel = 2
    ,mbYes = 3
    ,mbNo = 4
}

export interface SaopMsgDlgEvent {
    parent:any;
    data:any;
}

type SaopMsgDlgButtons = Array<SaopMsgDlgButton>;



export class SaopMessageDlg {
    private _sender:SaopMsgDlgEvent;
    private _modalParent:boolean = false;
    //
    public onOk?: (sender:any) => any;
    public onCancel?: (sender:any) => any;
    public onYes?: (sender:any) => any;
    public onNo?: (sender:any) => any;
    public onHide?: (sender:any) => any;
    public afterShow?: (sender:any) => any;

    constructor(sender:SaopMsgDlgEvent){
        this._sender = sender;
    }

    Show(Msg:string,Title:string,DlgType:SaopMsgDlgType = SaopMsgDlgType.mtInformation,Buttons:SaopMsgDlgButtons = [SaopMsgDlgButton.mbOK], BlurBackground: boolean = false, PreventClose: boolean = false):SaopMsgDlgButton | undefined{
        global.ConsoleLogDegug("message:"+Msg);
        global.ConsoleLogDegug("title:"+Title);

        this.resetButtons();


        let _this = this;
        this._modalParent = $("body").hasClass("modal-open");

        const $modal = $('#alert-modal');

        let titleDiv = $modal.find('#alert-modal-title-div');
        let bodyTag = $modal.find('#alert-modal-body');

        if (DlgType == SaopMsgDlgType.mtInformation){
            titleDiv.css("background-color","white");
        } else if (DlgType == SaopMsgDlgType.mtError) {
            titleDiv.css("background-color","#D82C25");
        } else {
            titleDiv.css("background-color","silver");            
        }

        if (!isEmpty(Title)){
            titleDiv.html(Title);
        }
        
        bodyTag.html(Msg);

        const $btnOK = $modal.find('#btnAlertOK');
        const $btnCancel = $modal.find('#btnAlertCancel');
        const $btnYes = $modal.find('#btnAlertYes');
        const $btnNo = $modal.find('#btnAlertNo');

        if (Buttons !== null) {
            let _element_mbOK = Buttons.find(element => element === SaopMsgDlgButton.mbOK);
            if (isUnDefined(_element_mbOK)) {
               $btnOK.attr("style", "display: none !important");
            } else {
                $btnOK.attr("style", "display: inline-block !important");
                $btnOK.off("click");
                $btnOK.click(
                    function () {
                        $btnOK.show();
                        if (!isUnDefined(_this.onOk)){
                            _this.onOk!(_this._sender);
                        }
                        return SaopMsgDlgButton.mbOK;
                    }
                );                
            }
            //
            let _element_mbCancel = Buttons.find(element => element === SaopMsgDlgButton.mbCancel);
            if (isUnDefined(_element_mbCancel)) {
                $btnCancel.attr("style", "display: none !important");
            } else {
                $btnCancel.attr("style", "display: inline-block !important");
                $btnCancel.off("click");
                $btnCancel.click(
                    function () {
                        if (!isUnDefined(_this.onCancel)){
                            _this.onCancel!(_this._sender);
                        }
                        return SaopMsgDlgButton.mbCancel;
                    }
                );                 
            }
            //
            let _element_mbYes = Buttons.find(element => element === SaopMsgDlgButton.mbYes);
            if (isUnDefined(_element_mbYes)) {
                $btnYes.attr("style", "display: none !important");
            } else {
                $btnYes.attr("style", "display: inline-block !important");
                $btnYes.off("click");
                $btnYes.click(
                    function () {
                        if (!isUnDefined(_this.onYes)){
                            _this.onYes!(_this._sender);
                        }
                        return SaopMsgDlgButton.mbYes;
                    }
                );                 
            }            
            //
            let _element_mbNo = Buttons.find(element => element === SaopMsgDlgButton.mbNo);
            if (isUnDefined(_element_mbNo)) {
                $btnNo.attr("style", "display: none !important");
            } else {
                $btnNo.attr("style", "display: inline-block !important");
                $btnNo.off("click");
                $btnNo.click(
                    function () {
                        if (!isUnDefined(_this.onNo)){
                            _this.onNo!(_this._sender);
                        }
                        return SaopMsgDlgButton.mbNo;
                    }
                );                 
            }             
        } else {
            $btnOK.attr("style", "display: none !important");
            $btnCancel.attr("style", "display: none !important");
            $btnYes.attr("style", "display: none !important");
            $btnNo.attr("style", "display: none !important");
            return SaopMsgDlgButton.mbNone;
        }

        $modal.on('hidden.bs.modal', function (e) {
            $modal.find("#alert-modal-btn-ok").unbind("click");
            $(this).modal('dispose');
            $('body').removeClass('saop-alert-blur');
            if (!isUnDefined(_this.onHide)){
                _this.onHide!(_this._sender);
            }        
            if (_this._modalParent) {
                $("body").addClass("modal-open");
            }    
            _this.afterShow = undefined;
            _this.resetButtons($modal);
        })

        let backdropOption: boolean | 'static' = true;
        let keyboardOption: boolean = true;

        if (PreventClose) {
            backdropOption = 'static';
            keyboardOption = false;  
        }
    
        $modal.modal({
            backdrop: backdropOption,
            keyboard: keyboardOption,
            show: true
        });

        setModalFormZIndex('#alert-modal'); 

        if (BlurBackground) {
             $('body').addClass('saop-alert-blur');
        }

        if (!isUnDefined(_this.afterShow)){
            _this.afterShow!(_this._sender);
        }        
    }

    public Close(): void {
        $('#alert-modal').modal('hide');
        
    }

    public IsVisible(): boolean {
        return $('#alert-modal').is(':visible'); 
    }

    private resetButtons($modal: JQuery<HTMLElement> = $('#alert-modal')): void {
        const allBtnIds = ["#btnAlertOK", "#btnAlertCancel", "#btnAlertYes", "#btnAlertNo"];
        
        allBtnIds.forEach(id => {
            const btn = $modal.find(id);
            btn.prop('disabled', false); 
            btn.removeClass('disabled');
        });
    }

    //
}





